import React from "react";
import styles from "./NewsCard.module.sass";
import { useNavigate } from "react-router-dom";

export default function NewsCard({
  Image,
  title,
  description,
  category,
  date,
  isSmall,
  url,
  className = ""
}) {
  const navigate = useNavigate();
  const handleNavigation = (path, params = {}) => {
    navigate(path, { state: params });
  }
  return (
    <>
      <div
        onClick={() => handleNavigation(`/news/${url || ""}`)}
        className={styles.container}
        // style={isSmall ? { maxWidth: "386px" } : null}
      >
        <div className={styles.innerContainer}>
          <div className={styles.upperContainer}>
            <img
              src={Image}
              alt="news image"
              style={isSmall ? { height: "208px" } : null}
            />
          </div>
          <div className={styles.lowerContainer}>
            <div className={`${styles.nameDate} ${className}`}>
              <p>{category}</p>
              <p>{date}</p>
            </div>
            <div className={styles.titleDescContainer}>
              <h1
                style={
                  isSmall ? { fontSize: "18px", lineHeight: "24px" } : null
                }
              >
                {title}
              </h1>
              {description && description?.length > 0 ? (
                <p>{description}</p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
